import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiStatusCityQuickInfo extends Layout {
    sourceEdistatus: DataSource;
    textboxCurrAddress: Textbox;
    textboxCurrCityName: Textbox;
    textboxCurrContactName: Textbox;
    textboxCurrLatitude: Textbox;
    textboxCurrLocId: Textbox;
    textboxCurrLocName: Textbox;
    textboxCurrLongitude: Textbox;
    textboxCurrPhone: Textbox;
    textboxCurrState: Textbox;
    textboxCurrStopType: Textbox;
    textboxCurrZipCode: Textbox;
    textboxPartnerLocation: Textbox;
    textboxPartnerStop: Textbox;
}
